/* eslint-disable */
export default {
  noActiveCalls: 'No hay ninguna llamada activa',
  noRecords: 'No hay resultados.',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noRecords"@#@ @source: @#@"No results found."@#@
